import { formatCurrency } from '@/helpers/CurrencyHelpers'
import environment from '@/helpers/Environment'
import currencyFormatter from 'currency-formatter'
import concat from 'lodash/concat'
import trim from 'lodash/trim'

/**
 * @deprecated All these should be helper functions.
 */
export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        /**
         * TODO Support internationalization.
         *
         * @deprecated Move to a pure helper function in @/helpers/CurrencyHelpers.
         *
         * The intention is to split the total to be
         * displayed into three components of: symbol, whole numbers, and
         * decimal, while also being agnostic about how the currency should be
         * formatted. Then the template can use those components in specific
         * markup. At the moment the template always places the symbol on the left.
         *
         * Probably builtin Internationalization API with a polyfill is the best solution;
         * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat/formatToParts
         * @see https://github.com/tc39/proposal-intl-formatToParts
         * @see https://www.npmjs.com/package/intl
         *
         * @returns {array}
         */
        formatCurrencyParts(amount) {
          const currency = this.getCurrencyFormatter().findCurrency(this.getDefaultCurrencyCode())
          const formatted = formatCurrency(amount)

          return concat([(amount < 0 ? '-' : '') + currency.symbol], trim(formatted, ` -${currency.symbol}`).split('.'))
        },

        /**
         * @deprecated Import the module directly.
         */
        getCurrencyFormatter() {
          return currencyFormatter
        },

        /**
         * @deprecated Access via environment.portal
         */
        getDefaultCurrencyCode() {
          // Provide a default to make the code easier to test.
          return environment.portal.default_currency_code || 'USD'
        },
      },
    })
  },
}
